var _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLockupLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 436 100",
    width: 436,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#E4DDCE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.7,
    y: 0,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#E4DDCE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.4,
    y: 0,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#E4DDCE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.1,
    y: 0,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#E4DDCE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.8,
    y: 0,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#C8922A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 20.7,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#E4DDCE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.7,
    y: 20.7,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#E4DDCE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.4,
    y: 20.7,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#E4DDCE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.1,
    y: 20.7,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#211D18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.8,
    y: 20.7,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#211D18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 41.4,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#E4DDCE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.7,
    y: 41.4,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#E4DDCE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.4,
    y: 41.4,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#211D18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.1,
    y: 41.4,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#211D18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.8,
    y: 41.4,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#211D18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 62.1,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#E4DDCE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.7,
    y: 62.1,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#211D18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.4,
    y: 62.1,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#211D18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.1,
    y: 62.1,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#211D18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.8,
    y: 62.1,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#211D18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 82.8,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#211D18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.7,
    y: 82.8,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#211D18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.4,
    y: 82.8,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#211D18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.1,
    y: 82.8,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#211D18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.8,
    y: 82.8,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#211D18"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 124,
    y: 68,
    fontFamily: "Lora, Georgia, 'Times New Roman', serif",
    fontWeight: 700,
    fontSize: 66,
    fill: "#2B2620"
  }, "terminal")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLockupLight);
export default __webpack_public_path__ + "static/media/logo-lockup-light.7b88fb16f64ff5afb3971713acbd5452.svg";
export { ForwardRef as ReactComponent };